/**
 * SASADM-0176 (saas-auth SASATH-0391/0392) — a write refused with
 * `409 HOSTNAME_IS_REDIRECT_TARGET`: another hostname redirects to the one it would remove. The
 * server message as-is (else the catalog sentence), plus the redirecting source rows when the
 * caller could map `error.details.hostnameIds` to hostnames. saas-admin can clear the redirect
 * itself, so the line points at "Other hostnames".
 */
import { Alert, Box } from '@mui/material';
import type { ApiError } from '@/api/errors';
import { useCopy } from '@/hooks/useCopy';

export function RedirectTargetNotice({
  err,
  sourceHostnames,
  onClose,
}: {
  err: ApiError;
  sourceHostnames: string[];
  onClose: () => void;
}) {
  const { t } = useCopy();
  return (
    <Alert severity="error" sx={{ mb: 2 }} onClose={onClose} closeText={t('common.close', 'Close')}>
      {err.details.message ??
        t(
          'errors.codes.HOSTNAME_IS_REDIRECT_TARGET',
          'Another hostname redirects to this one. Change or remove that redirect first.',
        )}
      {sourceHostnames.length > 0 && (
        <Box component="span" sx={{ display: 'block', mt: 0.5 }}>
          {t(
            'hostnames.redirect.sources',
            'Redirecting here: {{list}} — change them under Other hostnames.',
            { list: '{{list}}' },
          )
            .split('{{list}}')
            .map((piece, i) =>
              i === 0 ? (
                piece
              ) : (
                <Box component="span" key={i}>
                  <Box component="span" sx={{ fontFamily: 'monospace' }}>
                    {sourceHostnames.join(', ')}
                  </Box>
                  {piece}
                </Box>
              ),
            )}
        </Box>
      )}
    </Alert>
  );
}
